module.exports = __webpack_public_path__ + "static/media/finance.11a3b20b.svg";